module.exports = __webpack_public_path__ + "static/media/hero-online-1.ec42e22d.png";